import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Chip, Paper } from '@mui/material';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { ptBR } from '@mui/x-data-grid/locales/';
import EditIcon from '@mui/icons-material/Edit';
import api from '../services/api.js';

function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const getAllUsers = async () => {
    try {
      setLoading(true);
      const response = await api.get('/users');
      setUsers(response.data.data);
    } catch (err) {
      setUsers([]);
      showError(err.response?.data?.message || 'Algo de errado aconteceu.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (isMounted) await getAllUsers();
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  const showError = (message) => {
    const alert = <Alert
      className="error-content"
      variant="outlined"
      severity="error"
    >
      {message}
    </Alert>;
    setError(alert);
    setTimeout(() => setError(null), 3000);
  };

  const handleEditClick = (username) => navigate(`/usuarios/editar/${username}`);
  const handleNewClick = () => navigate('/usuarios/novo');
  const paginationModel = { page: 0, pageSize: 25 };

  const columns = [
    { field: 'id', sortable: true, headerName: 'ID', width: 90 },
    { field: 'name', sortable: true, headerName: 'Nome', flex: 3 },
    {
      field: 'username',
      sortable: true,
      headerName: 'Usuário',
      flex: 1.3,
    },
    {
      field: 'isActive',
      sortable: true,
      headerName: 'Status',
      width: 120,
      renderCell: ({value}) => <Chip
        label={value ? 'Ativo' : 'Inativo'}
        color={value ? 'success' : 'error'}
        variant="outlined"
        size="small"
      />
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Ações',
      width: 70,
      cellClassName: 'actions',
      getActions: (item) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Editar"
            className="textPrimary"
            onClick={() => handleEditClick(item.row.username)}
            color="inherit"
          />,
        ];
      },
    }
  ];

  return (
    <div>
      {error}
      <div className="align-center justify-between">
        <h1>Usuários</h1>
        <Button
          sx={{ width: '150px', height: '40px' }}
          variant="outlined"
          color="primary"
          onClick={handleNewClick}
        >
          Cadastrar
        </Button>
      </div>
      <Paper>
        <DataGrid
          density="compact"
          loading={loading}
          rows={users}
          columns={columns}
          initialState={{
            pagination: { paginationModel },
            pinnedColumns: {
              left: ['desk'],
            },
          }}
          pageSizeOptions={[25, 50, 100]}
          slotProps={{
            loadingOverlay: {
              variant: 'skeleton',
              noRowsVariant: 'skeleton',
            },
          }}
          sx={{ border: 0 }}
          localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
        />
      </Paper>
    </div>
  );
}

export default Users;
